
import React from 'react';

const WordpressSVG = () =>
  <svg height="53px" width="53px" version="1.1" viewBox="0 0 53 53">
    <g fill="none" stroke="none" strokeWidth="1">
      <g transform="translate(-3395.000000, -807.000000)">
        <g transform="translate(3395.000000, 807.000000)">
          <path d="M52.509,26.2544 C52.509,11.7544 40.755,0.0004 26.255,0.0004 C11.755,0.0004 0,11.7544 0,26.2544 C0,40.7544 11.755,52.5094 26.255,52.5094 C40.755,52.5094 52.509,40.7544 52.509,26.2544" fill="#ECECEC"/>
          <g transform="translate(12.000000, 13.000000)">
            <path d="M26.9866,25.3501 L1.5226,25.3501 L1.5226,3.0691 C1.5226,2.0141 2.3776,1.1591 3.4326,1.1591 L25.0766,1.1591 C26.1316,1.1591 26.9866,2.0141 26.9866,3.0691 L26.9866,25.3501 Z" fill="#FFFFFF"/>
            <path d="M26.2366,24.6001 L26.2366,3.0691 C26.2366,2.42831356 25.7173864,1.9091 25.0766,1.9091 L3.4326,1.9091 C2.79181356,1.9091 2.2726,2.42831356 2.2726,3.0691 L2.2726,24.6001 L26.2366,24.6001 Z M0.7726,26.1001 L0.7726,3.0691 C0.7726,1.59988644 1.96338644,0.4091 3.4326,0.4091 L25.0766,0.4091 C26.5458136,0.4091 27.7366,1.59988644 27.7366,3.0691 L27.7366,26.1001 L0.7726,26.1001 Z" fill="#222228"/>
            <polygon fill="#222228" points="1.5227 5.7286 26.9867 5.7286 26.9867 4.2286 1.5227 4.2286"/>
            <path d="M5.229,14.2751 L5.229,8.3191 L23.281,8.3191 L23.281,14.2751 L5.229,14.2751 Z M21.781,12.7751 L21.781,9.8191 L6.729,9.8191 L6.729,12.7751 L21.781,12.7751 Z" fill="#EC5424"/>
            <polygon fill="#222228" points="23.324 16.5318 5.224 16.5318 5.224 18.0318 23.324 18.0318"/>
            <polygon fill="#222228" points="17.2629 20.0489 5.2239 20.0489 5.2239 21.5489 17.2629 21.5489"/>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default WordpressSVG;


// WEBPACK FOOTER //
// ./src/svg/WordpressSVG.js